import { User } from './user';

export enum NotificationType {
  LAYOUT = 'layout',
  LAYOUT_PRODUCTION = 'layout_production',
  ART_ACTIVITY = 'art_activity',
  PAYMENT_SLIP = 'payment_slip',
  PRODUCTION_APPROVAL = 'production_approval',
  BALANCE_REQUEST_APPROVAL = 'balance_request_approval',
  STOCK_REQUEST = 'stock_request',
  WITHDRAWAL = 'withdrawal',
  ORDER_PRICE = 'order_price',
  MATERIAL_ASSOCIATED = 'material_associated',
}

export type Notification = {
  id: number;
  user: number;
  title: string;
  message: string;
  type: NotificationType;
  data?: Record<string, any>;
  createdAt: Date;
};

export type NotificationPopulated = Omit<Notification, 'user'> & {
  user: User;
};
